import React from "react";

const BackBenefits = () => {
  return (
    <div className="faceWaxingContainer">
      <h2>
        The Benefits of Choosing SCENT for Body Back Waxing, De-tan & Threading
        in Bangalore
      </h2>{" "}
      <li>
        <h6>Long-Lasting Results:</h6> Our Body Back Waxing services provide
        longer-lasting hair removal compared to shaving. Enjoy smooth skin for
        weeks, and over time, experience reduced hair growth.
      </li>
      <li>
        <h6>Enhanced Skin Tone:</h6> Our De-tan Treatments not only reduce tan
        but also rejuvenate your skin, making it look brighter and more
        youthful. Say goodbye to uneven skin tone and hello to a radiant
        complexion.
      </li>
      <li>
        <h6>Precise Hair Removal:</h6> Threading offers unparalleled precision
        in hair removal, ensuring clean lines and a flawless appearance. It’s
        perfect for achieving a well-groomed look without the hassle of frequent
        touch-ups.
      </li>
    </div>
  );
};

export default BackBenefits;
